var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiContext = function SvgAiContext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai-context_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#ACB5C2",
    strokeWidth: 4,
    d: "M20 2a6 6 0 1 1 0 12 6 6 0 0 1 0-12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 26,
    r: 4,
    fill: "#ACB5C2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 26,
    r: 4,
    fill: "#ACB5C2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ai-context_svg__b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m6 16 14 5.5V38L6 34z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ai-context_svg__c)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m34 16-14 5.5V38l14-4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-context_svg__b",
    x1: 6,
    x2: 26.035,
    y1: 38,
    y2: 26.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60F3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00CCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-context_svg__c",
    x1: 34,
    x2: 13.965,
    y1: 38,
    y2: 26.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60F3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00CCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AC0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-context_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export { SvgAiContext as ReactComponent };
export default __webpack_public_path__ + "fonts/ai-context-b50a87270631cd041dd7a84ab739b8e5.svg";